import { CalendarEvent } from '@models/common/calendar-event.model';

export class Day {
    date: Date;
    events: CalendarEvent[] = [];
    isExpanded: boolean;
    numberOfEventsViewableWhenNotExpanded = 5;
    isToday: boolean;

    expand(): void {
        this.isExpanded = true;
    }

    shrink(): void {
        this.isExpanded = false;
    }

    toggleExpansion(): void {
        this.isExpanded = !this.isExpanded;
    }

    get isEmpty(): boolean {
        return this.events.length === 0;
    }

    get numberOfEventsToShow(): number {
        if (this.isExpanded) {
            return this.events.length;
        }
        return this.numberOfEventsViewableWhenNotExpanded;
    }

    get numberOfViewableEvents(): number {
        return this.numberOfEventsToShow < this.events.length ? this.numberOfEventsToShow : this.events.length;
    }

    get viewableEvents(): CalendarEvent[] {
        if (this.isExpanded) {
            return this.events;
        }

        return this.events.slice(0, this.numberOfEventsViewableWhenNotExpanded);
    }

    get hasHiddenEvents(): boolean {
        return this.events.length > this.numberOfViewableEvents;
    }

    get numberOfHiddenEvents(): number {
        return this.events.length - this.numberOfViewableEvents;
    }

    get isShowingMoreEventsThanDefault(): boolean {
        return this.numberOfViewableEvents > this.numberOfEventsViewableWhenNotExpanded;
    }
}
